<div>
  <a
    title="card view"
    role="button"
    aria-label="card view"
    data-test-selector="cards-toggle"
    *ngIf="!isCardViewDisabled && isCardViewRouterLink"
    ngbTooltip="The selected filter is not available in card view."
    [triggers]="isCardViewDisabled ? 'hover' : 'manual'"
    [routerLink]="cardViewUrl"
  >
    <span
      class="far fa-th-large fa-lg"
      [ngClass]="isCardView ? 'selected' : ''"
    >
    </span>
  </a>

  <a
    title="card view"
    role="button"
    aria-label="card view"
    data-test-selector="cards-toggle"
    *ngIf="!isCardViewDisabled && !isCardViewRouterLink"
    ngbTooltip="The selected filter is not available in card view."
    [triggers]="isCardViewDisabled ? 'hover' : 'manual'"
    [href]="cardViewUrl"
  >
    <span
      class="far fa-th-large fa-lg"
      [ngClass]="isCardView ? 'selected' : ''"
    >
    </span>
  </a>

  <span
    class="far fa-th-large fa-lg text-gray-300"
    *ngIf="isCardViewDisabled"
    data-test-selector="cards-toggle-tooltip"
    ngbTooltip="The selected filter is not available in card view."
    [triggers]="isCardViewDisabled ? 'hover' : 'manual'"
  >
  </span>

  <a
    title="list view"
    role="button"
    *ngIf="isListViewRouterLink"
    aria-label="list view"
    data-test-selector="list-toggle"
    [routerLink]="listViewUrl"
  >
    <span class="far fa-list fa-lg" [ngClass]="!isCardView ? 'selected' : ''">
    </span>
  </a>
  <a
    title="list view"
    role="button"
    *ngIf="!isListViewRouterLink"
    aria-label="list view"
    data-test-selector="list-toggle"
    [href]="listViewUrl"
  >
    <span class="far fa-list fa-lg" [ngClass]="!isCardView ? 'selected' : ''">
    </span>
  </a>
</div>
